const makeWebHookUrl = "https://hook.us1.make.com/7rj2roxisargoo8qav8rr1eo7kxa900w";

export { makeWebHookUrl };